shadow$provide[418] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying float vPixelSize;

float getCircleMask(vec2 uv) {
  return dot(uv, uv);
}
`;

};